<div class="design-elements">
  <div class="body scrollbar-y">
    @for (section of elementSections; track section) {
      <div>
        <div class="field section-header">
          <div class="flex-label">
            {{ 'COMMUNICATIONS.DESIGNER.ELEMENTS-SECTION-' + section | translate }}
            @if (section === 2) {
              <i [matTooltip]="'COMMUNICATIONS.SMS-TOOLTIP-MESSAGE' | translate"
                class="tooltip-icon-info icon icon-help"
                matTooltipPosition="right"
                [matTooltipShowDelay]="500">
              </i>
            }
          </div>
          @for (elementType of elementTypes; track elementType.value) {
            <div>
              @if (elementType.section === section) {
                <div (dragstart)="dragItem($event, elementType.value)"
                  draggable="true"
                  class="design-element"
                  [ngClass]="{ 'disabled': disabledElements?.includes(elementType.value) }">
                  <i class="icon {{ elementType.icon }} mr-2"></i>
                  {{ elementType.title | translate }}
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
